import {useEffect,useState} from 'react'
import {useSelector} from 'react-redux'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {envAwarePost} from '../../util/util'
import { Doughnut } from 'react-chartjs-2'
import 'chartjs-plugin-labels'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const dataDisplayText = (data_key,isMAXUser) =>({
	workout:'Workouts',
	task:'Tasks',
	nutrition:'Nutrition',
	simplified_nutrition:(isMAXUser?'MAX Nutrition':'Simplified Nutrition'),
}[data_key])

const sixDaysAgo = ()=>{
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate()-6);
}

const Compliance = props =>{
	const [rangeType,setRangeType] = useState(null)
	const [status,setStatus] = useState('idle')
	const [customComplianceData,setCustomComplianceData] = useState(null)
	const [weeklyComplianceData,setWeeklyComplianceData] = useState(null)
	const [monthlyComplianceData,setMonthlyComplianceData] = useState(null)
	const complianceData = {
		weekly:weeklyComplianceData,
		monthly:monthlyComplianceData,
		//default to weekly data if no data present for custom range
		custom:customComplianceData||weeklyComplianceData
	}[rangeType]
	const [fromDate,setFromDate] = useState(sixDaysAgo())
	const [toDate,setToDate] = useState(new Date())
	const isMAXUser = Boolean(useSelector(state=>state.users.current_user.isMAXUser))
	const getWeeklyCompliance = ()=>{
		setRangeType('weekly')
		//if data already fetched don't re-fetch
		if(weeklyComplianceData) return
		setStatus('loading')
		envAwarePost('api/fit-stats/api.php',{
			action:'getWeeklyCompliance'
		}).then(res=>{
			setStatus('idle')
			if(res.success == 1) setWeeklyComplianceData(res.data)
		})
	}
	const getMonthlyCompliance = ()=>{
		setRangeType('monthly')
		//if data already fetched don't re-fetch
		if(monthlyComplianceData) return
		setStatus('loading')
		envAwarePost('api/fit-stats/api.php',{
			action:'getMonthlyCompliance'
		}).then(res=>{
			setStatus('idle')
			if(res.success == 1) setMonthlyComplianceData(res.data)
		})
	}
	const getComplianceInRange = ()=>{
		setStatus('loading')
		const from_date = fromDate.toISOString().slice(0,10)
		const to_date = toDate.toISOString().slice(0,10)
		envAwarePost('api/fit-stats/api.php',{
			action:'getComplianceInRange',
			from_date,to_date
		}).then(res=>{
			setStatus('idle')
			if(res.success == 1) setCustomComplianceData(res.data)
		})
	}
	useEffect(getWeeklyCompliance,[])
	const labels = ['Complete','Open','Not Met']
	const colors = ['#3fd953','#4160e8','#e85241']
	const eventKeys = ['workout','task','nutrition','simplified_nutrition']
	return (
		<div style={{padding:'16px'}}>
			<div className="text-center my-3">
				<h2 className="shadow" style={{
					padding:'16px 32px',
					background:'#000C2D',
					color:'#eee',
					borderRadius:'100px',
					display:'inline-block'
				}}>
					<i style={{color:'#adb0c2'}} className="fas fa-calendar-week"></i> Compliance Stats
				</h2>
			</div>
			<div style={{
				padding:'16px',
				background:'#000C2D',
				boxShadow:'0 0 16px rgba(0,0,0,0.3)',
				borderRadius:'4px',
				color:'#ccc'
			}}>
				<small className="d-block text-center mb-1">
					Compliance Data for Workouts, Tasks, and Nutrition:
				</small>
				<div style={{height:'31px'}} className="d-flex justify-content-center align-items-center">
					<ButtonGroup>
						<Button 
							disabled={status==='loading'} 
							variant={
								rangeType==='weekly'?
								"light" :
								"outline-light"
							}
							size="sm" 
							onClick={getWeeklyCompliance}>
							7 days
						</Button>
						<Button
							disabled={status==='loading'}
							variant={
								rangeType==='monthly'?
								"light" :
								"outline-light"
							}
							size="sm" 
							onClick={getMonthlyCompliance}>
							30 days
						</Button>
						<Button 
							onClick={()=>setRangeType('custom')} 
							disabled={status==='loading'} 
							variant={
								rangeType==='custom'?
								"light" :
								"outline-light"
							}
							size="sm">
							Custom
						</Button>
					</ButtonGroup>
				</div>
				{rangeType==='custom'&&
					<div className="d-flex align-items-center justify-content-center flex-wrap mt-2">
						<div className="d-flex">
							<DatePicker 
								selected={fromDate}
								onChange={(date)=>{
									setFromDate(date)
								}}
								customInput={<input style={{width:'100px',height:'31px',lineHeight:'31px'}}/>}
								className="mr-1 text-center border rounded" 
								placeholder="subscribe"/>
							<DatePicker 
								selected={toDate}
								onChange={(date)=>{
									setToDate(date)
								}}
								customInput={<input style={{width:'100px',height:'31px',lineHeight:'31px'}}/>}
								className="mr-1 text-center border rounded" 
								placeholder="subscribe"/>
						</div>
						<Button onClick={getComplianceInRange} disabled={status==='loading'} variant="outline-light" size="sm">
							apply
						</Button>
					</div>
				}
				{
					complianceData&&status!=='loading'?
					<div>
						<div className="d-flex justify-content-center w-100 flex-wrap">
							{labels.map((label,i)=>{
								const color = colors[i]
								return (
									<div className="d-flex p-2 align-items-center">
										<span className="mr-2" style={{
											background:color,
											width:'16px',
											height:'16px',
											borderRadius:'100%',
											display:'inline-block'
										}}/>
										<span style={{color:'#ccc'}}>
											{label}
										</span>
									</div>
								)
							})}
						</div>
						<div className="d-flex justify-content-around flex-wrap">
							{eventKeys.map(key=>{
								//don't show nutrition data for MAX
								if(key==='nutrition' && isMAXUser) return null
								const chartData = (
									key !== 'simplified_nutrition' ?
									[
										parseInt(complianceData[key].complete),
										parseInt(complianceData[key].open),
										parseInt(complianceData[key].notMet)
									] : [
										parseInt(complianceData[key].completed),
										parseInt(complianceData[key].assigned)-parseInt(complianceData[key].completed),
									]
								)
								if(!chartData.reduce((accumulator, currentValue) => accumulator + currentValue)){
									return null
								}
								const chartLabels = (
									key !== 'simplified_nutrition' && key !== 'max_nutrition'?
									['Complete','Open','Not Met'] :
									['Completed','Not Met']
								)
								const chartColors = (
									key !== 'simplified_nutrition' ?
									['#3fd953','#4160e8','#e85241'] :
									['#3fd953','#e85241']
								)
								return (
									<div>
										<div style={{width:'200px',height:'200px'}}>
											<Doughnut 
												data={{
													labels:chartLabels,
													datasets:[{
														backgroundColor:chartColors,
														data:chartData
													}]
												}}
												options={{
													legend:{
														display:false
													},
													maintainAspectRatio:false,
													responsive:true,
													//no need for tooltips
													tooltips:{
														enabled:false
													},
													//no need for color hover change
													hover:{mode:null},
													plugins:{
														labels:[
															{
																render:'percentage',
																position:'border',
																fontColor:'#fff',
																fontSize:16,
																precision:1
															}
														]
													}
												}}/>
										</div>
										<p className="text-center">{dataDisplayText(key,isMAXUser)}</p>
									</div>
								)//end return chart
							})}
						</div>
					</div>:
					<div className="d-flex justify-content-center">
						<Spinner animation="border" role="status">
							<span className="sr-only">Loading...</span>
						</Spinner>
					</div>
				}
			</div>
		</div>
	)
}

export default Compliance